// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/main." + "3ee34126586de91b3a97" + ".css";
};